import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PreferencesService } from '../preferences/preferences.service';
import { UserPreferences } from '../preferences/preferences.domain';
import {
  NotificationsLocation,
  NotificationsPreferencesType,
  NotificationsStatus
} from './notifications-preferences.domain';

@Injectable({
  providedIn: 'root'
})
export class NotificationsPreferencesService {
  constructor(private preferencesService: PreferencesService) {
  }

  getNotificationsPreferences(): Observable<NotificationsPreferencesType> {
    return this.preferencesService.getUserPreferences()
      .pipe(map((userPreference: UserPreferences): NotificationsPreferencesType => {
        const preferences: NotificationsPreferencesType = {} as NotificationsPreferencesType;
        if (typeof userPreference.FILL_NOTIFICATIONS_STATUSES !== 'undefined') {
          preferences.showNotificationStatus = userPreference.FILL_NOTIFICATIONS_STATUSES as Array<NotificationsStatus> ;
        }
        if (typeof userPreference.FILL_NOTIFICATIONS_LOCATION !== 'undefined') {
          preferences.notificationLocation = userPreference.FILL_NOTIFICATIONS_LOCATION as NotificationsLocation;
        }
        if (typeof userPreference.FILL_NOTIFICATIONS_TIME !== 'undefined') {
          preferences.notificationFadeOutTime = userPreference.FILL_NOTIFICATIONS_TIME as number;
        }
        return preferences;
      }));
  }

  saveNotifications(preferencesNotificationSettings: NotificationsPreferencesType): Observable<UserPreferences> {
    const notificationSettings: UserPreferences = {
      FILL_NOTIFICATIONS_LOCATION: preferencesNotificationSettings.notificationLocation,
      FILL_NOTIFICATIONS_TIME: preferencesNotificationSettings.notificationFadeOutTime,
      FILL_NOTIFICATIONS_STATUSES: preferencesNotificationSettings.showNotificationStatus
    };
    return this.preferencesService.updateUserPreferences(notificationSettings);
  }
}
